import './services-bottom.sass';
import { Container, Row, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

import image11 from '../../assets/images/image11.png';
import image12 from '../../assets/images/image12.png';
import image13 from '../../assets/images/image13.png';

function Services_bottom() {
  const { t } = useTranslation();

  const images_list1_bottom = [
    {
      src: image11,
      largeDesc: t('services_list1_bottom.image11.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list1_bottom.image11.0.smallDesc'),
    },
    {
      src: image12,
      largeDesc: t('services_list1_bottom.image12.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list1_bottom.image12.0.smallDesc'),
    },
    {
      src: image13,
      largeDesc: t('services_list1_bottom.image13.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list1_bottom.image13.0.smallDesc'),
    },
  ];

  return (
    <Container fluid className="services-bottom-container">
      <Row className="services-bottom-row">
        <h2 className="h2-services"><Trans i18nKey="services_bottom_title"/></h2>
        <Swiper
          grabCursor={true}
          slidesPerView={3}
          spaceBetween={30}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          pagination={{ clickable: true, dynamicBullets: true }}
          modules={[Autoplay, Pagination]}
          className="swiper-slide"
          breakpoints={{
            0: { slidesPerView: 1 }, //  Show 1 slide on small screens (mobile)
            768: { slidesPerView: 2 }, //  Show 2 slides on tablets
            1024: { slidesPerView: 3 }, //  Show 3 slides on desktops
          }}
        >
          {images_list1_bottom.map((images_list1, index) => (
            <SwiperSlide key={index}>
              <Image src={images_list1.src} fluid className="image" />
              <div className="div-small-price">
                <span className="span-small">{images_list1.smallDesc}</span>
                <span className="span-price">{images_list1.price}</span>
              </div>
              <div className="div-large">
                <span className="span-large">{images_list1.largeDesc}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Row>
    </Container>
  );
}

export { Services_bottom };
